import React from "react"
import styled from "styled-components"

const InnerDiv = styled.div`
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  padding: 1em;

  background-color: rgb(79, 114, 132);
`

/**
 * A card is a simple component that renders it's content
 * slighly heigthened above the surface, with some padding
 * and a background color that ensures consistent coloring
 * throughout the application.
 */
export class Card extends React.Component<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> {
  public render() {
    const { children, ...rest } = this.props
    return <InnerDiv {...(rest as any)}>{children}</InnerDiv>
  }
}
